import { render, staticRenderFns } from "./UiTaxRateSelector.vue?vue&type=template&id=1f8f87c3&scoped=true"
import script from "./UiTaxRateSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiTaxRateSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f87c3",
  null
  
)

export default component.exports